import React from 'react';
import {Link, useParams} from 'react-router-dom'

import './MBlock.css';

import background_img from '../../assets/images/background.svg'

function App(props) {

    const textosProps = {
        titulo:   "Marco Bloqueado",
        legenda:  "O marco pesquisado está bloqueado. Termine os marcos anteriores para poder acessar",
        btn_texto:"Voltar para a página dos planetas",
        btn_to:   "/planetas/"
    };

    const params = useParams();
    const motivo = Number(params.motivo || props.motivo || 1 )

    if (motivo===2){ // bloqueado por tempo
        textosProps.legenda = "O marco foi bloqueada pelo professor, volte no dia da próxima aula para acessar"
    }

    if (motivo===3){ // bloqueado por tempo
        textosProps.titulo =    "Marco em Manutenção"
        textosProps.legenda=    "O marco pesquisado está em manutenção, tente novamente amanhã"
        textosProps.btn_texto=  "Voltar para a página dos planetas"
        textosProps.btn_to=     "/planetas/"
    }

    return (
        <MissoBloqueadaDefault
          titulo    = {textosProps.titulo}
          legenda   = {textosProps.legenda}
          btn_texto = {textosProps.btn_texto}
          btn_to    = {textosProps.btn_to}
        />
    )
}

export default App;

function MissoBloqueadaDefault(props) {

  const { titulo, legenda, btn_texto, btn_to } = props;

  return (
    <div className="misso-bloqueada-default">
      <div className="overlap-group" style={{ backgroundImage: `url(${background_img})` }}>
        <div className="corpo">
          <div className="textos">
            <h1 className="titulo valign-text-middle archivo-bold-log-cabin-89px">{titulo}</h1>
            <div className="legenda poppins-regular-normal-log-cabin-20px">{legenda}</div>
          </div>
          <Link to={btn_to} className="boto djbtn">
            <div className="text-1 valign-text-middle archivo-semi-bold-white-18px">{btn_texto}</div>
          </Link>
        </div>
      </div>
    </div>
  );
}
